module.exports = "/_next/static/images/WhatIsCustomerData@2x-76d20f5e72383f1286ce694a2ba24f43.webp";